/**
 * Ключи браузерного хранилища — ОДНО место на всё приложение.
 *
 * Раньше `SyncManager` держал собственную копию строки `'onboardix_token'`:
 * прямой импорт из `api/core.js` даёт цикл (core импортирует сам SyncManager).
 * Копия означала, что переименование ключа тихо деградирует — очередь молча
 * продолжала бы читать несуществующее значение. Модуль-константы разрывает
 * цикл и оставляет одну точку правды.
 */
export const ONBOARDIX_TOKEN_KEY = 'onboardix_token'
export const ONBOARDIX_USER_KEY = 'onboardix_user'
